module.exports = {"411725001":"盘龙街道","411725002":"三里河街道","411725003":"朗陵街道","411725101":"竹沟镇","411725102":"任店镇","411725103":"新安店镇","411725104":"留庄镇","411725105":"刘店镇","411725107":"瓦岗镇","411725108":"双河镇","411725109":"石滚河镇","411725110":"李新店镇","411725209":"普会寺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411725.json
// module id = 1543
// module chunks = 0